module.exports = __webpack_public_path__ + "img/HC3P_BannerCropped.89123a53.jpg";